import { render, staticRenderFns } from "./PushNotificationsOptIn.vue?vue&type=template&id=00731970&scoped=true&"
import script from "./PushNotificationsOptIn.vue?vue&type=script&lang=js&"
export * from "./PushNotificationsOptIn.vue?vue&type=script&lang=js&"
import style0 from "./PushNotificationsOptIn.vue?vue&type=style&index=0&id=00731970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00731970",
  null
  
)

export default component.exports